import { useState } from 'react';
import { format, subDays } from 'date-fns';

export const useSearchFilters = (initialFilters = {}) => {
  const {
    searchTerm: initialSearchTerm = '',
    startDate: initialStartDate = format(subDays(new Date(), 90), 'YYYY-MM-DD'),
    endDate: initialEndDate = format(Date.now(), 'YYYY-MM-DD'),
    age: initialAge = '',
    program: initialProgram = null,
    lastPromoted: initialLastPromoted = true,
  } = initialFilters;

  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [age, setAge] = useState(initialAge);
  const [program, setProgram] = useState(initialProgram);
  const [lastPromoted, setLastPromoted] = useState(initialLastPromoted);

  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };

  const handleProgramChange = (event) => {
    setProgram(event.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(format(e.target.value, 'YYYY-MM-DD'));
  };

  const handleStartDateChange = (e) => {
    setStartDate(format(e.target.value, 'YYYY-MM-DD'));
  };
  return {
    handleProgramChange,
    program,
    setProgram,
    searchTerm,
    setSearchTerm,
    setLastPromoted,
    lastPromoted,
    startDate,
    endDate,
    age,
    handleAgeChange,
    handleEndDateChange,
    handleStartDateChange,
  };
};
